import styles from "./card.module.scss";

export const CardItemWrap = ({
  children,
  direction,
  gap = 0,
  className,
  style = {},
}: {
  children: React.ReactNode;
  direction?: "horizontal" | "vertical";
  gap?: number;
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className={`${styles["card-item-wrap"]} ${className ? className : ""}`}
      style={{
        flexDirection: direction === "horizontal" ? "row" : "column",
        gap: gap + "px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const CardItem = ({
  className,
  type = "",
  children,
  onClick,
  style = {},
}: {
  className?: string;
  type?: "shadow" | "simple" | "simple-narrow" | "";
  children: React.ReactNode;
  onClick?: (e?: React.MouseEvent<HTMLDivElement>) => void;
  style?: React.CSSProperties;
}) => {
  return (
    <div
      className={`${styles["card-item"]} ${type ? styles["card-item-" + type] : ""} ${className ? className : ""}`}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        onClick && onClick(e);
      }}
      style={{
        ...style,
      }}
    >
      {children}
    </div>
  );
};
export const CardInnerItem = ({
  children,
  autoWidth = true,
  direction = "horizontal",
  gap = {
    column: 14,
    row: 0,
  },
  className,
  style = {},
}: {
  children: React.ReactNode;
  autoWidth?: boolean;
  direction?: "horizontal" | "vertical";
  gap?: {
    column: number;
    row: number;
  };
  className?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <>
      <div
        className={`${styles["card-inner-item"]} ${className ? className : ""}`}
        style={{
          width: `${autoWidth ? "" : "100%"}`,
          flexDirection: direction === "horizontal" ? "row" : "column",
          columnGap: `${gap.column}px`,
          rowGap: `${gap.row}px`,
          ...style,
        }}
      >
        {children}
      </div>
    </>
  );
};
